import { useCsAttribute } from "./useCsAttribute";
import { useLocalEditState } from "./useLocalEditState";
/**
 * Get the current local value of an edit attribute
 * - requires {@linkcode CsAttributeController}
 *
 * @category Hook
 * @template T The type depends on the attribute
 * @category CsAttribute
 * @export
 * @returns
 */
export function useLocalEditValue() {
    var _a;
    const attribute = useCsAttribute();
    const editState = useLocalEditState();
    // values[0] is selected if the users enters a custom text
    const selectedValue = (_a = attribute.values) === null || _a === void 0 ? void 0 : _a.find((value) => value.isSelected);
    const serverValue = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value;
    const localValue = editState[attribute.path];
    return localValue !== null && localValue !== void 0 ? localValue : serverValue;
}
//# sourceMappingURL=useLocalEditValue.js.map